// DevisModel.js
import DevisLigneModel from "./DevisLigneModel";
import UserModel from "./UserModel";

class DevisModel {
    constructor(data) {
        this.id = data.id || null;
        this.user_id = data.user_id || null;
        this.client_id = data.client_id || null;

        this.numero = data.numero || null;
        this.date_emission = data.date_emission || null;
        this.date_expiration = data.date_expiration || null;
        this.statut = data.statut || "brouillon";

        this.titre = data.titre || null;
        this.notes_client = data.notes_client || null;
        this.notes_internes = data.notes_internes || null;

        this.sous_total_centimes = data.sous_total_centimes || 0;
        this.remise_centimes = data.remise_centimes || 0;
        this.tva_centimes = data.tva_centimes || 0;
        this.total_centimes = data.total_centimes || 0;
        this.devise = data.devise || "EUR";

        // Relations
        this.client = data.client || null; // objet complet client
        this.user = data.user ? new UserModel(data.user) : null; // objet complet user
        this.lignes = data.lignes
            ? data.lignes.map((ligne) => new DevisLigneModel(ligne))
            : [];
        // Nouveaux champs pour les secteurs
        this.secteurs_batiment = data.secteurs_batiment || []; // tableau {id, nom}
        this.secteurs_autres = data.secteurs_autres || [];     // tableau {id, nom}
        this.created_at = data.created_at || null;
        this.updated_at = data.updated_at || null;
        this.deleted_at = data.deleted_at || null;
    }
}

export default DevisModel;
